import { render, staticRenderFns } from "./RatingClassificationSelector.vue?vue&type=template&id=1930aded&scoped=true"
import script from "./RatingClassificationSelector.vue?vue&type=script&lang=js"
export * from "./RatingClassificationSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1930aded",
  null
  
)

export default component.exports